import { render, staticRenderFns } from "./dangCheList.vue?vue&type=template&id=3600b314&"
import script from "./dangCheList.vue?vue&type=script&lang=js&"
export * from "./dangCheList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports